import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteAnnouncement = async (id: number): Promise<void> => {
	await cmsClient.delete(`/announcements/${id}/`);
};

const useDeleteAnnouncement = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message="Announcement deleted successfully"
			/>,
			{ hideProgressBar: true }
		);
		queryClient.invalidateQueries(["announcements"]);
	};

	const onError = (error: unknown) => {
		const axiosError = error as AxiosError;
		const message =
			axiosError?.response?.status === 409
				? "Only draft announcements can be deleted."
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(deleteAnnouncement, { onError, onSuccess });
	return mutation;
};

export default useDeleteAnnouncement;
